import {
  AiFieldThinkingPlaceholder,
  useIsAiFieldCellProcessing
} from '@databases/database-ai-fields';
import { DatabaseValueViewContainer } from '@databases/styles';
import React, { type FunctionComponent } from 'react';

import DatabaseValueView, { type DatabaseValueViewProps } from './DatabaseValueView';

const AiSummaryFieldReadView: FunctionComponent<DatabaseValueViewProps> = ({
  contentId,
  fieldId,
  entryId,
  ...props
}) => {
  const isAiFieldCellProcessing = useIsAiFieldCellProcessing({
    contentId,
    aiFieldType: 'summary',
    fieldId,
    entryId
  });

  if (isAiFieldCellProcessing) {
    return (
      <DatabaseValueViewContainer data-testid="database-value-view-container">
        <AiFieldThinkingPlaceholder />
      </DatabaseValueViewContainer>
    );
  }

  return (
    <DatabaseValueView
      {...props}
      contentId={contentId}
      fieldId={fieldId}
      entryId={entryId}
    />
  );
};

export default AiSummaryFieldReadView;
